module.exports = __webpack_public_path__ + "static/img/8.bced9c35.png";